import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const user_endpoints = APIS_ENDPOINTS.user

export const request_getuserbyid = async ({userId}) => {
  return http.get(user_endpoints.getuserbyid + '?Id=' + userId)
}

export const request_adduserposhetoken = async ({deviceId}) => {
  return http.post(user_endpoints.adduserposhetoken + '?deviceId=' + deviceId)
}

export const request_userprofile = async ({UserId}) => {
  return http.get(user_endpoints.userprofile + '?UserId=' + UserId)
}

export const request_getallemployeeinsurancebyuserprofileid = async ({UserProfileId}) => {
  return http.get(
    user_endpoints.getallemployeeinsurancebyuserprofileid + '?UserProfileId=' + UserProfileId
  )
}

export const request_getallcompanyplacesbyuserprofileid = async ({UserProfileId}) => {
  return http.get(
    user_endpoints.getallcompanyplacesbyuserprofileid + '?UserProfileId=' + UserProfileId
  )
}

export const request_getallboardofdirectorsbyuserprofileid = async ({UserProfileId}) => {
  return http.get(
    user_endpoints.getallboardofdirectorsbyuserprofileid + '?UserProfileId=' + UserProfileId
  )
}

export const request_getalllegalshareholderbyuserprofileid = async ({UserProfileId}) => {
  return http.get(
    user_endpoints.getalllegalshareholderbyuserprofileid + '?UserProfileId=' + UserProfileId
  )
}

export const request_getalluser = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    user_endpoints.getalluser +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_loginusertowepapp = async (phoneNumber: string) => {
  return http.get(user_endpoints.adminLoginToUserWebApp + '?PhoneNumber=' + phoneNumber)
}

export const request_editphonenumberbyadmin = async ({userId, phoneNumber}) => {
  return http.put(
    user_endpoints.editphonenumberbyadmin + '?User=' + userId + '&PhoneNumber=' + phoneNumber
  )
}

export const request_editusertypebyadmin = async ({
  userId,
  userType,
  firstName = '',
  lastName = '',
  email = '',
  nationalCode = '',
  birthDate = '',
  landLinePhone = '',
  companyName = '',
  registrationNumber = '',
  nationalId = '',
  profileImageFile = '',
}) => {
  const formData = new FormData()
  formData.append('Id', userId)
  formData.append('UserType', userType)
  formData.append('FirstName', firstName)
  formData.append('LastName', lastName)
  formData.append('Email', email)
  formData.append('NationalCode', nationalCode)
  formData.append('BirthDate', birthDate)
  formData.append('LandLinePhone', landLinePhone)
  formData.append('CompanyName', companyName)
  formData.append('RegistrationNumber', registrationNumber)
  formData.append('NationalId', nationalId)
  formData.append('ProfileImageFile', profileImageFile)

  return http.put(user_endpoints.editusertypebyadmin, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const request_disableboardofdirectorvalidation = async ({BoardOfDirectorId, UserId}) => {
  return http.post(
    user_endpoints.disableboardofdirectorvalidation +
      '?BoardOfDirectorId=' +
      BoardOfDirectorId +
      '&UserId=' +
      UserId
  )
}

export const request_disablecompanystep2validation = async ({UserId}) => {
  return http.post(user_endpoints.disablecompanystep2validation + '?UserId=' + UserId)
}

export const request_disablecompanyvalidation = async ({UserId}) => {
  return http.post(user_endpoints.disablecompanyvalidation + '?UserId=' + UserId)
}

export const request_activecompanyvalidation = async ({UserId}) => {
  return http.post(user_endpoints.activecompanyvalidation + '?UserId=' + UserId)
}

export const request_activeboardofdirectorvalidation = async ({BoardOfDirectorId, UserId}) => {
  return http.post(
    user_endpoints.activecompanyvalidation +
      '?BoardOfDirectorId=' +
      BoardOfDirectorId +
      '&UserId=' +
      UserId
  )
}

export const request_changeuserpass = async ({
  id,
  password,
  confirmPassword,
}: {
  id: number
  password: string
  confirmPassword: string
}) => {
  return http.post(user_endpoints.changepasswordwithadmin, {
    id,
    password,
    confirmPassword,
  })
}

// استعلام چک برگشتی حقوقی‌
export const request_getlegalbackcheques = async (nationalId: string) => {
  return http.get(user_endpoints.getlegalbackcheques + '?nationalId=' + nationalId)
}

// استعلام چک برگشتی حقیقی
export const request_getnaturalbackcheques = async (nationalId: string) => {
  return http.get(user_endpoints.getnaturalbackcheques + '?nationalId=' + nationalId)
}

// استعلام تسهیلات (حقیقی/حقوقی)
export const request_getuserfacilityinquiry = async (nationalId: string) => {
  return http.get(user_endpoints.getuserfacilityinquiry + '?nationalId=' + nationalId)
}
